import {Component} from "@angular/core";

@Component({
    selector: 'notification',
    templateUrl: './notification.component.html',
})
export class NotificationComponent {

    public message: string = "";

    constructor() {
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/notification/notification-component/notification.component.ts